module.exports = __webpack_public_path__ + "static/media/php.08ddcd8f.svg";